export const fieldTitleStyle = {
  marginBottom: '$3'
}

export const asteriskStyle = {
  color: '$error-standard'
}
